/** Shared Clerk component theme — Spotify dark surface. */
export const clerkAppearance = {
  variables: {
    colorPrimary: "#1ed760",
    colorBackground: "#181818",
    colorNeutral: "#ffffff",
    colorInputBackground: "#121212",
    colorInputText: "#ffffff",
    colorText: "#ffffff",
    colorTextSecondary: "#b3b3b3",
    colorTextOnPrimaryBackground: "#000000",
    colorDanger: "#e57373",
    borderRadius: "0.5rem",
    fontFamily: "Figtree Variable, Helvetica Neue, Helvetica, Arial, sans-serif",
  },
  elements: {
    rootBox: "w-full max-w-md",
    card: "bg-panel shadow-none border border-line",
    headerTitle: "text-text",
    headerSubtitle: "text-muted",
    socialButtonsBlockButton:
      "bg-panel-elevated border border-line hover:bg-row-hover !text-text",
    socialButtonsBlockButtonText: "!text-text font-medium",
    formFieldLabel: "text-muted",
    formFieldInput: "bg-sidebar border-line text-text",
    footerActionLink: "text-accent hover:text-accent-hover",
    identityPreviewText: "text-text",
    identityPreviewEditButton: "text-accent",
  },
} as const;
